import { useEffect, useSyncExternalStore } from "react";

let focusedClientId: string | null = null;
const listeners = new Set<() => void>();

const setFocusedClientId = (clientId: string | null) => {
    if (focusedClientId === clientId) {
        return;
    }
    focusedClientId = clientId;
    listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

const getSnapshot = () => focusedClientId;
const getServerSnapshot = () => null;

/**
 * Reports the client the mounted org Tasks page is focused on, or `null`.
 * Cleared when the page unmounts.
 */
export const useReportFocusedTasksClient = (clientId: string | null) => {
    useEffect(() => {
        setFocusedClientId(clientId);
        return () => setFocusedClientId(null);
    }, [clientId]);
};

/** The client the org Tasks page is focused on, for the side nav's client rows. */
export const useFocusedTasksClientId = (): string | null =>
    useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
